import { z } from 'zod';
import { Currency } from '../enums';

export const HardwareLibrarySchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  category: z.string(),
  vendor: z.string(),
  manufacturer: z.string(),
  model_number: z.string().nullable(),
  cost_per_unit: z.number().default(0),
  shipping_cost: z.number().default(0),
  currency: z.nativeEnum(Currency).default(Currency.USD),
  iva_percent: z.number().default(0),
  unit: z.string().default('each'),
  install_minutes: z.number().nullable(),
  notes: z.string().nullable(),
  active: z.boolean().default(true),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});

export const CreateHardwareLibrarySchema = z.object({
  name: z.string().min(1, 'Name is required'),
  category: z.string().min(1, 'Category is required'),
  vendor: z.string().optional().default(''),
  manufacturer: z.string().optional().default(''),
  model_number: z.string().nullable().optional(),
  cost_per_unit: z.number().default(0),
  shipping_cost: z.number().default(0),
  currency: z.nativeEnum(Currency).default(Currency.USD),
  iva_percent: z.number().default(0),
  unit: z.string().default('each'),
  install_minutes: z.number().nullable().optional(),
  notes: z.string().nullable().optional(),
  active: z.boolean().default(true),
});

export const UpdateHardwareLibrarySchema = CreateHardwareLibrarySchema.partial();

export type HardwareLibrary = z.infer<typeof HardwareLibrarySchema>;
export type CreateHardwareLibrary = z.infer<typeof CreateHardwareLibrarySchema>;
export type UpdateHardwareLibrary = z.infer<typeof UpdateHardwareLibrarySchema>;
